import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcArrowrightFillNomargin(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "6",
    height: "12",
    fill: "none",
    viewBox: "0 0 6 12",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.66 12a.63.63 0 0 1-.463-.198.7.7 0 0 1-.197-.521V.719Q0 .395.199.198A.64.64 0 0 1 .662 0q.067 0 .46.223l4.575 5.014q.158.172.23.357A1.1 1.1 0 0 1 6 6a1.1 1.1 0 0 1-.073.406 1.2 1.2 0 0 1-.23.357l-4.575 5.014a.7.7 0 0 1-.211.163.54.54 0 0 1-.25.06"
  }));
}
var IcArrowrightFillNomargin = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowrightFillNomargin));

export { IcArrowrightFillNomargin as I };
